<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedBenificario" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedBenificario"
                           :load-data="loadDataBeneficiario"
                           :entity="entity"
                           :auth-token="authToken" :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataBeneficiario"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
    <component v-if="view === 'actualizar'" :is="extraComponent" :selected-data="selectedBenificario"
               :auth-token="authToken"></component>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import BeneficiariosCrearActualizarComponent
  from "@/components/parametros/components/BeneficiariosCrearActualizarComponent";
import {useLayoutMain} from "@/layouts/main";

export default {
  name: 'BeneficiariosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    BeneficiariosCrearActualizarComponent,
  },
  data: function () {
    return {
      Object: Object,
      title: 'Beneficiarios',
      entity: {gender: 'm', value: 'beneficiario'},
      childFormComponent: 'beneficiariosCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'nit': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'NIT'
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del beneficiario'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedBenificario = ref({
      id: '',
      nit: '',
      nombre: '',
      estado: ''
    });
    const loadDataBeneficiario = ref({
      nit: '',
      nombre: ''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_BENEFICIARIO_CREATE,
      list: process.env.VUE_APP_NEST_BENEFICIARIO_FINDALL,
      update: process.env.VUE_APP_NEST_BENEFICIARIO_UPDATE,
      updateState: process.env.VUE_APP_NEST_BENEFICIARIO_UPDATESTATE
    });
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedBenificario, loadDataBeneficiario, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedBenificario,
      loadDataBeneficiario,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    };
  }
}
</script>